import { PropsWithChildren } from 'react'
import { Modal, BaseActionButtons } from 'shared/components'
import {
  Wrapper,
  DialogDescription,
  DialogTitle,
  DialogContentContainer,
  DialogButtonsContainer,
} from './DialogWithTitleAndButtons.style'
import { DialogProps } from './DialogWithTitleAndButtons.types'

const Dialog = ({
  open,
  onClose,
  variant,
  children,
  title,
  description,
  dialogButtons,
  buttonsAligment,
  buttonsDirection,
  enableMinWidth,
  idPrefix,
  disableCloseIcon,
  ...props
}: PropsWithChildren<DialogProps>) => {
  return (
    <Modal
      idPrefix={`${idPrefix}-modal`}
      open={open}
      onClose={onClose}
      disableBackdropClick
      displayCloseIcon={!!disableCloseIcon && disableCloseIcon ? false : true}
    >
      <Wrapper {...props} variant={variant} enableMinWidth={enableMinWidth}>
        <DialogContentContainer>
          {title && <DialogTitle>{title}</DialogTitle>}
          {description && <DialogDescription>{description}</DialogDescription>}
          {children}
        </DialogContentContainer>
        {dialogButtons && (
          <DialogButtonsContainer
            aligment={buttonsAligment}
            direction={buttonsDirection}
          >
            <BaseActionButtons
              {...dialogButtons}
              idPrefix={idPrefix}
              onCancel={dialogButtons.onCancel}
            />
          </DialogButtonsContainer>
        )}
      </Wrapper>
    </Modal>
  )
}

export default Dialog
